import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

export const selectInnerScheduleEvents = (state: RootState) => state.schedule.events;

export const selectScheduleEvents = createSelector(
    [selectInnerScheduleEvents],
    (events) => events.map(event => {
        let start, end;
        switch (event.type) {
            case 'AM練習':
                start = event.startTime ? `${event.date}T${event.startTime}` : `${event.date}T09:00`;
                end = event.endTime ? `${event.date}T${event.endTime}` : `${event.date}T13:00`;
                break;
            case 'PM練習':
                start = event.startTime ? `${event.date}T${event.startTime}` : `${event.date}T13:00`;
                end = event.endTime ? `${event.date}T${event.endTime}` : `${event.date}T17:00`;
                break;
            case '公式戦':
            case '練習試合':
                start = event.startTime ? `${event.date}T${event.startTime}` : `${event.date}T09:00`;
                end = event.endTime ? `${event.date}T${event.endTime}` : `${event.date}T13:00`;
                break;
        }

        return { id: event.id, title: event.type, start, end, place: event.place, description: event.description }
    })
);
